import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

import { FormatCoinCurrencyPipe } from '../../pipes/format-coin-currency.pipe';

@Component({
  selector: 'app-available-balance',
  standalone: true,
  imports: [FormatCoinCurrencyPipe],
  templateUrl: './available-balance.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './available-balance.component.scss',
})
export class AvailableBalanceComponent {
  @Input() balance: number | null = null;
  @Input() currencySymbol = '';
  @Input() precision = 2;
  @Input() showMax = false;
  @Output() maxClicked = new EventEmitter<number>();

  onMaxClick(): void {
    if (this.balance === null) return;
    const effectivePrecision = Math.min(this.precision, 6);
    const factor = Math.pow(10, effectivePrecision);
    const truncated = Math.trunc(this.balance * factor) / factor;
    this.maxClicked.emit(truncated);
  }
}
